<template>
  <div class="modal-content">
    <div class="modal-body">
      <smart-device-link-details :model-value="selectedSmartDeviceLink" v-on:update:modelValue="save" v-on:close="hideModal" v-on:remove="remove" />
    </div>
  </div>
</template>

<script>

import SmartDeviceLinkDetails from '~/components/SmartDeviceLinkDetails'

export default {
  props: ['selectedSmartDeviceLink'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (smartdevice) {
      this.$emit('save', smartdevice)
    },
    remove (smartdevice) {
      this.$emit('remove', smartdevice)
    }
  },
  components: {
    SmartDeviceLinkDetails
  }
}

</script>